import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class EmployeeConfirmapplyApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'employee-confirmapply'
  }

}